const myMM = {
  name: 'my_MM',
  global: {
    undo: 'ပြန်ရုပ်သိမ်း',
    redo: 'ပြန်လုပ်ပါ။',
    confirm: 'အတည်ပြုပါ။',
    clear: 'ရှင်းရန်'
  },
  Popconfirm: {
    positiveText: 'အတည်ပြုပါ။',
    negativeText: 'မလုပ်တော့'
  },
  Cascader: {
    placeholder: 'ကျေးဇူးပြု။ ရွေးချယ်ပါ',
    loading: 'ဒိန်း',
    loadingRequiredMessage: label => `${label} ၏ ကလေး node အားလုံးကို တင်ပြီးမှသာ ရွေးချယ်နိုင်သည်။`
  },
  Time: {
    dateFormat: 'yyyy-MM-dd',
    dateTimeFormat: 'yyyy-MM-dd HH:mm:ss'
  },
  DatePicker: {
    yearFormat: 'yyyyတစ်နှစ်',
    monthFormat: 'MMM',
    dayFormat: 'eeeeee',
    yearTypeFormat: 'yyyy',
    monthTypeFormat: 'yyyy-MM',
    dateFormat: 'yyyy-MM-dd',
    dateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
    quarterFormat: 'yyyy-qqq',
    clear: 'ရှင်းရန်',
    now: 'ယခု',
    confirm: 'အတည်ပြုပါ။',
    selectTime: 'ရွေးချယ်ရေးကာလ',
    selectDate: 'ရက်စွဲကိုရွေးချယ်ပါ။',
    datePlaceholder: 'ရက်စွဲကိုရွေးချယ်ပါ။',
    datetimePlaceholder: 'ရက်စွဲအချိန်ကိုရွေးချယ်ပါ။',
    monthPlaceholder: 'လကိုရွေးပါ။',
    yearPlaceholder: 'နှစ်ကိုရွေးချယ်ပါ။',
    quarterPlaceholder: 'လေးပုံတစ်ပုံကို ရွေးပါ။',
    startDatePlaceholder: 'စတင်သည့်ရက်စွဲ',
    endDatePlaceholder: 'ကုန်ဆုံးရက်',
    startDatetimePlaceholder: 'စတင်မည့်ရက်စွဲအချိန်',
    endDatetimePlaceholder: 'ကုန်ဆုံးရက်စွဲအချိန်',
    startMonthPlaceholder: 'စတင်လ',
    endMonthPlaceholder: 'လကုန်',
    monthBeforeYear: false,
    firstDayOfWeek: 0,
    today: 'ဒီနေ့'
  },
  DataTable: {
    checkTableAll: 'ဇယားဒေတာအားလုံးကို ရွေးပါ။',
    uncheckTableAll: 'ဇယားဒေတာအားလုံးကို ရွေးချယ်မှုဖြုတ်ပါ။',
    confirm: 'အတည်ပြုပါ။',
    clear: 'ပြန်လည်သတ်မှတ်ပါ။'
  },
  LegacyTransfer: {
    sourceTitle: 'အရင်းအမြစ်အခေါ်အဝေါ်',
    targetTitle: 'ပစ်မှတ်အရာ'
  },
  Transfer: {
    selectAll: 'အားလုံးကို ရွေးပါ။',
    clearAll: 'ရှင်းရန်',
    unselectAll: 'အားလုံးရွေးချယ်မှုမပြု',
    total: num => `စုစုပေါင်း ${num} ပစ္စည်းများ`,
    selected: num => `${num} ဖိုင်များကို ရွေးထားသည်။`
  },
  Empty: {
    description: 'ဒေတာမရှိပါ။'
  },
  Select: {
    placeholder: 'ကျေးဇူးပြု။ ရွေးချယ်ပါ'
  },
  TimePicker: {
    placeholder: 'အချိန်တစ်ခုကို ရွေးပါ။',
    positiveText: 'အတည်ပြုပါ။',
    negativeText: 'မလုပ်တော့',
    now: 'ယခု'
  },
  Pagination: {
    goto: 'သို့ခုန်ပါ။',
    selectionSuffix: 'စာမျက်နှာ'
  },
  DynamicTags: {
    add: 'ထည့်သည်'
  },
  Log: {
    loading: 'ဒိန်း'
  },
  Input: {
    placeholder: 'ကျေးဇူးပြု၍ ဝင်ပါ။'
  },
  InputNumber: {
    placeholder: 'ကျေးဇူးပြု၍ ဝင်ပါ။'
  },
  DynamicInput: {
    create: 'ထည့်သည်'
  },
  ThemeEditor: {
    title: 'အပြင်အဆင်အယ်ဒီတာ',
    clearAllVars: 'variable အားလုံးကိုရှင်းလင်းပါ။',
    clearSearch: 'ရှင်းရှင်းလင်းလင်းရှာဖွေမှု',
    filterCompName: 'filter အစိတ်အပိုင်းအမည်',
    filterVarName: 'ပြောင်းလဲနိုင်သောအမည်ကို စစ်ထုတ်ပါ။',
    import: 'တင်သွင်းခြင်း။',
    export: 'တင်ပို့ခြင်း။',
    restore: 'ပြန်လည်သတ်မှတ်ပါ။'
  },
  Image: {
    tipPrevious: 'အရင်（←）',
    tipNext: 'နောက်တစ်ခု（→）',
    tipCounterclockwise: 'ဘယ်ဘက်သို့လှည့်ပါ။',
    tipClockwise: 'ညာဘက်လှည့်',
    tipZoomOut: 'ချဲ့ကြည့်ပါ။',
    tipZoomIn: 'ချဲ့ပါ။',
    tipClose: 'ပိတ် (Esc)',
    tipOriginalSize: 'မူရင်းအရွယ်အစားသို့ ချဲ့ပါ။'
  }
};
export default myMM;
